import {
  DataEntryAccidentStepSectionProps,
  FormikWitness,
  typedMemo,
  YesNoAnswer,
} from "src/types";
import { Button, FormRow, InputGroup } from "src/ui/widgets";
import { WitnessForm } from "./witness";
import { useDataEntryAccidentStepWitnesses } from "./accident-step-witnesses.hook";
import { FormikErrors, FormikTouched } from "formik";
import { ChangeEvent } from "react";

export const DataEntryAccidentStepWitnesses = typedMemo(
  (props: DataEntryAccidentStepSectionProps) => {
    const {
      formikAccidentValues,
      formikAccidentErrors,
      formikAccidentTouched,
      formik,
      validationSchema,
    } = props;

    const { handleChange, handleBlur } = formik;

    const {
      isMobile,
      authorityTypeOptions,
      yesNoOptions,
      disableAddWitnesses,
      removeWitnessButtonVisible,
      t,
      onAddWitnessClick,
      onRemoveWitnessClick,
      onSelectAuthorityInterventionQuestion,
    } = useDataEntryAccidentStepWitnesses(props);

    return (
      <>
        <div>
          {formikAccidentValues.witnessesInfo?.witnessesList?.map(
            (witness, index) => (
              <WitnessForm
                key={witness.fiscalCode}
                witness_number={index}
                formikWitnessValues={
                  formikAccidentValues.witnessesInfo?.witnessesList?.[index]
                }
                formikWitnessErrors={
                  formikAccidentErrors?.witnessesInfo?.witnessesList?.[
                    index
                  ] as FormikErrors<FormikWitness>
                }
                formikWitnessTouched={
                  formikAccidentTouched?.witnessesInfo?.witnessesList?.[
                    index
                  ] as FormikTouched<FormikWitness>
                }
                formik={formik}
                validationSchema={validationSchema}
              />
            )
          )}
        </div>
        <div className="d-flex gap-4 justify-content-center mb-5 mt-2">
          {removeWitnessButtonVisible && (
            <Button
              flavor="primaryFlipRemove"
              classes="px-auto py-2"
              text={`${t("commons.delete")} ${t("commons.witness")} `}
              classesText="text-uppercase label-l--500"
              onPress={onRemoveWitnessClick}
            />
          )}

          <Button
            disabled={disableAddWitnesses}
            flavor="primaryAdd"
            classes="px-auto py-2"
            text={`${t("commons.add")} ${t("commons.witness")} `}
            classesText="text-uppercase label-l--500"
            onPress={onAddWitnessClick}
          />
        </div>
        <FormRow
          firstField={
            <InputGroup
              style="radio"
              name="accidentData.witnessesInfo.authorityIntervention"
              handleChange={(event: ChangeEvent<HTMLInputElement>) => {
                onSelectAuthorityInterventionQuestion(event);
                handleChange(event);
              }}
              handleBlur={handleBlur}
              options={yesNoOptions}
              validationSchema={validationSchema}
              touched={
                formikAccidentTouched?.witnessesInfo?.authorityIntervention
              }
              value={formikAccidentValues.witnessesInfo?.authorityIntervention}
              error={formikAccidentErrors?.witnessesInfo?.authorityIntervention}
              label={t(
                "data_entry.accident_step.section_witnesses_authoirty_question"
              )}
              classes="m-0 ps-0"
              classesLabel="m-0 p-0 d-flex align-items-center mb-3"
            />
          }
        />
        {formikAccidentValues.witnessesInfo?.authorityIntervention ===
          YesNoAnswer.YES && (
          <FormRow
            firstField={
              <InputGroup
                vertically={isMobile ? true : false}
                style="checkbox"
                name="accidentData.witnessesInfo.authority"
                handleChange={handleChange}
                handleBlur={handleBlur}
                options={authorityTypeOptions}
                validationSchema={validationSchema}
                touched={formikAccidentTouched?.witnessesInfo?.authority}
                value={formikAccidentValues.witnessesInfo?.authority}
                error={formikAccidentErrors?.witnessesInfo?.authority}
                classes="m-0 ps-0"
                classesLabel="m-0 p-0 d-flex align-items-center mb-3"
              />
            }
          />
        )}
      </>
    );
  }
);
